export default "__VITE_ASSET__Bf_d1QZz__"